import { useState, useEffect } from 'react';

/**
 * Hook to detect if the user is on a mobile device based on window width.
 * Standard mobile breakpoint: 768px.
 * 
 * SOLID: Responsibility is solely device detection logic.
 */
export const useDevice = (breakpoint: number = 768) => {
  const [isMobile, setIsMobile] = useState<boolean>(
    typeof window !== 'undefined' ? window.innerWidth < breakpoint : false
  );

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const handleResize = () => {
      setIsMobile(window.innerWidth < breakpoint);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [breakpoint]);

  return { isMobile };
};
